export default __webpack_public_path__ + "static/media/build.94eea76e.svg";